import React from 'react';

export function PageTitle({ title }: { title: string }) {
  return <div className="page-title">{title}</div>;
}
